<template>
    <div class="bg-white isolate">
        <CmsContainer
            :structure="structure"
            :slug="slug" />
    </div>
</template>

<script setup>
import CmsContainer from "@/components/pages/cms/CmsContainer"

const [slug] = useRoute().params.slug === '' ? ['index'] : useRoute().params.slug.reverse()

const {data: structure} = await useAsyncGql('content', {slug: slug})

const title = computed(() => structure.value?.entries[0]?.title)

useHead({
    title: title,
})

definePageMeta({
    scrollToTop: true
})
</script>